// @flow
import { OFFER_DESCRIPTION } from 'Client/cms/toolkit/constants';
import { OfferDescriptionLine } from 'Components/lines/offer-description-line/OfferDescriptionLine';
import { offerDescriptionResolver } from './offerDescription.resolver';

export const offerDescriptionDescriptor = {
  name: OFFER_DESCRIPTION,
  component: OfferDescriptionLine,
  resolve: offerDescriptionResolver.resolve,
};
